require('./bootstrap');

import Vue from 'vue';
import MainMenu from './enso/MainMenu.js';
import SvgSprite from './vendor/enso/components/SvgSprite.vue';
import FlickityCarousel from './components/FlickityCarousel.vue';
import PostsIndex from './components/PostsIndex.vue';
import PostPreview from './components/PostPreview.vue';
import ContactForm from './components/ContactForm.vue';
import MouseTrail from './src/MouseTrail';
import ResponsiveVideoLoop from './components/ResponsiveVideoLoop';

new Vue({
  el: '#app',
  components: {
    MainMenu,
    SvgSprite,
    FlickityCarousel,
    PostsIndex,
    PostPreview,
    ContactForm,
    ResponsiveVideoLoop,
  },
});

const heroBtn = document.querySelector('.hero-btn');

if (heroBtn) {
  let pageHeight = window.innerHeight;
  let offset;
  if (window.innerWidth > 768) {
    offset = pageHeight - 80;
  } else {
    offset = pageHeight - 56;
  }

  heroBtn.addEventListener('click', (e) => {
    window.scroll({
      top: offset,
      left: 0,
      behavior: 'smooth',
    });
    e.preventDefault();
  });
}

/**
 * When the custom font loads the text re-renders. This results in the change of
 * content height. This results in what appears to be a scroll and the page
 * doesn't line up to the hash link. So we'll wait a second and then correct
 * that. This isn't ideal. Would be nicer to use scroll-margin-top but that's
 * not well supported enough yet.
 */
window.addEventListener('load', (event) => {
  if (window.location.hash) {
    window.setTimeout(() => {
      scrollToHash(window.location.hash);
    }, 1000);
  }
});

/**
 * Scroll to a given hash
 * @param {string} hash
 */
function scrollToHash(hash) {
  let offset_height = 0;

  const target = document.querySelector(hash);

  if (!target) {
    return;
  }

  let distance_scrolled = window.pageYOffset;
  let dist_from_viewport_top = target.getBoundingClientRect().top;
  let top_dist = distance_scrolled + dist_from_viewport_top;
  let scroll_dist = Math.max(0, top_dist - offset_height);

  scrollToY(scroll_dist, 250);
}

/**
 * Scroll to a given position
 *
 * @param {number} y        [Distance from top of page to scroll to]
 * @param {number} duration [Time to take in ms]
 */
function scrollToY(y, duration) {
  let start_y = window.pageYOffset;
  let diff = y - start_y;
  let start;

  y = Math.max(Math.min(y, 0));

  window.requestAnimationFrame(function step(timestamp) {
    if (!start) {
      start = timestamp;
    }

    function inOutQuintEasing(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    }

    let time = timestamp - start;
    let now = (timestamp - start) / duration;
    let ease = inOutQuintEasing(now);
    let percent = Math.min(time / duration, 1) * ease;
    let val = start_y + diff * percent;

    window.scrollTo(0, val);

    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}

const traceCanvas = document.getElementById('traceLine');
if (traceCanvas) {
  new MouseTrail(traceCanvas);
}

function findParentA(el) {
  do {
    if (el.nodeName === 'A') {
      return el;
    }
  } while ((el = el.parentNode));

  return null;
}

// A hack to override the target="_blank" that is set in the HTML in links
// within chat bot responses and instead open in the same window.
//
// The intention is for this to be fixed at the HTML lever but that's not
// possible right now
document.body.addEventListener('click', (event) => {
  if (event.target.matches('.rw-message a, .rw-message a *')) {
    const targetEl = findParentA(event.target);

    if (!targetEl) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const url = new URL(targetEl.href);

    let target = ['traceandcircle.com', 'trace-and-circle.maya.agency'].includes(url.hostname)
      ? '_self'
      : '_blank';

    window.open(url.href, target).focus();
  }
});

/**
 * Open chat window when a link with href of /#chat is clicked
 */
const chatBtns = document.querySelectorAll('a[href="/#chat"]');

chatBtns.forEach((button) => {
  button.addEventListener('click', (e) => {
    e.preventDefault();

    const launcher = document.querySelector('.rw-open-launcher');

    if (launcher) {
      launcher.click();
    }
  });
});
